import React from "react";
import { Box } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LoadingGif from "./LoadingGif";

const PageLoadingFallback = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#FCF8F3",
      }}
    >
      <Navbar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          flex: 1,
        }}
      >
        <LoadingGif />
      </Box>
      <Footer />
    </Box>
  );
};

export default PageLoadingFallback;
